@if (authorizePending) {
  <app-loading text="Authorizing user" />
} @else if (servicesLoading) {
  <app-loading text="Loading Services" />
} @else {
  @if (loading) {
    <div id="loading-overlay">
      <mat-spinner mode="indeterminate" />
    </div>
  }

  <app-header />

  <div id="notification-container" [class.padding-skip]="notifications.length === 0">
    @for (notification of notifications; track $index) {
      @if (isNotify(notification.id)) {
        <div class="notification">
          <div class="close" (click)="closeNotification(notification.id)">
            <mat-icon>close</mat-icon>
          </div>
          <div class="text">{{ notification.message }}</div>
        </div>
      }
    }
  </div>

  <div class="content-container container-fluid p-3">
    <router-outlet />
  </div>
}
